import { GsFormIfArgValue, GsFormIfOperator } from 'libs/shared/src/components';

export function schemaStringCompare(arg: GsFormIfArgValue, value: string | null | undefined, operator: GsFormIfOperator) {
  if (!operator) operator = '==';
  switch (operator) {
    case '==': {
      return compareEqual(arg, value);
    }
    case '!=': {
      return compareNotEqual(arg, value);
    }
    case '<': {
      return compareLessThan(arg, value);
    }
    case '>': {
      return compareGreaterThan(arg, value);
    }
    case '<=': {
      return compareLessThan(arg, value) || compareEqual(arg, value);
    }
    case '>=': {
      return compareGreaterThan(arg, value) || compareEqual(arg, value);
    }
    default: {
      return false;
    }
  }
}

function compareEqual(val0: GsFormIfArgValue, val1?: string | null): boolean {
  if (val0 === undefined || val0 === null) return val1 === undefined || val1 === null || val1 === '';
  switch (typeof val0) {
    case 'string':
      return val1 === val0;
    case 'number':
      return val1 === String(val0);
    case 'boolean':
      return compareBoolean(val0, val1);
    case 'object':
      if (Array.isArray(val0)) return val0.some((val) => schemaStringCompare(val, val1, '=='));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for string comparison: ${typeof val0}`);
      return val1 == String(val0);
  }
  return false;
}

function compareNotEqual(val0: GsFormIfArgValue, val1?: string | null): boolean {
  if (val0 === undefined || val0 === null) return val1 !== undefined && val1 !== null && val1 !== '';
  switch (typeof val0) {
    case 'string':
      return val1 != val0;
    case 'number':
      return val1 != String(val0);
    case 'boolean':
      return !compareBoolean(val0, val1);
    case 'object':
      if (val0 === null) return !!val1 && val1.length > 0;
      if (Array.isArray(val0)) return val0.some((val) => schemaStringCompare(val, val1, '!='));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for string comparison: ${typeof val0}`);
      return val1 != String(val0);
  }
  return false;
}

function compareLessThan(val0: GsFormIfArgValue, val1?: string | null): boolean {
  if (val0 === undefined || val0 === null) return val1 !== undefined && val1 !== null && val1 !== '';
  switch (typeof val0) {
    case 'string':
      return val1 ? val0 < val1 : false;
    case 'number':
      return val1 ? Number(val1) > val0 : false;
    case 'boolean':
      return !compareBoolean(val0, val1);
    case 'object':
      if (val0 === null) return !!val1 && val1.length > 0;
      if (Array.isArray(val0)) return val0.some((val) => schemaStringCompare(val, val1, '<'));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for string comparison: ${typeof val0}`);
      return val1 ? String(val0) < val1 : false;
  }
  return false;
}

function compareGreaterThan(val0: GsFormIfArgValue, val1?: string | null): boolean {
  if (val0 === undefined || val0 === null) return val1 !== undefined && val1 !== null && val1 !== '';
  switch (typeof val0) {
    case 'string':
      return val1 ? val0 > val1 : false;
    case 'number':
      return val1 ? Number(val1) < val0 : false;
    case 'boolean':
      return !compareBoolean(val0, val1);
    case 'object':
      if (val0 === null) return !!val1 && val1.length > 0;
      if (Array.isArray(val0)) return val0.some((val) => schemaStringCompare(val, val1, '>'));
      break;
    default:
      console.debug(`[SchemaService] Unsupported value type for string comparison: ${typeof val0}`);
      return val1 ? String(val0) > val1 : false;
  }
  return false;
}

function compareBoolean(val0: boolean, val1?: string | null): boolean {
  if (val0 === true) return !!val1 && val1.length > 0;
  if (val0 === false) return !val1 || val1 === '';
  return val0 === !!val1;
}
